import React from "react";
import "./ResourcesSection.css";

const ResourcesSection = () => {
  return (
    <section className="resources-section">
      <h2 className="resources-title">Resources</h2>
      <p className="resources-description">
        Explore helpful guides, product data sheets, recipes, and insights to get
        the most out of Biofana’s natural food powders.
      </p>
    </section>
  );
};

export default ResourcesSection;
